var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      {
        staticStyle: { cursor: "pointer" },
        on: {
          click: function ($event) {
            _vm.hideForm = !_vm.hideForm
          },
        },
      },
      [
        _c("h2", { staticClass: "text-center" }, [
          _vm._v("Carnet de rappel COVID 19"),
        ]),
        _vm._v(" "),
        _c("p", {}, [
          _vm._v("Merci de renseigner les informations ci-dessous :"),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "form-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.client.FullName,
              expression: "client.FullName",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text", placeholder: "Nom et Prénom*" },
          domProps: { value: _vm.client.FullName },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.client, "FullName", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _vm.FullName_msg
          ? _c(
              "p",
              {
                staticClass: "bg-danger",
                staticStyle: { "margin-top": "10px", padding: "10px" },
              },
              [_vm._v(_vm._s(_vm.FullName_msg))]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.client.Email,
              expression: "client.Email",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "email", name: "email", placeholder: "Email*" },
          domProps: { value: _vm.client.Email },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.client, "Email", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _vm.Email_msg
          ? _c(
              "p",
              {
                staticClass: "bg-danger",
                staticStyle: { "margin-top": "10px", padding: "10px" },
              },
              [_vm._v(_vm._s(_vm.Email_msg))]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.client.Mobile,
              expression: "client.Mobile",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text", placeholder: "Mobile*" },
          domProps: { value: _vm.client.Mobile },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.client, "Mobile", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _vm.Mobile_msg
          ? _c(
              "p",
              {
                staticClass: "bg-danger",
                staticStyle: { "margin-top": "10px", padding: "10px" },
              },
              [_vm._v(_vm._s(_vm.Mobile_msg))]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "checkbox" }, [
          _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.accept,
                  expression: "accept",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.accept)
                  ? _vm._i(_vm.accept, null) > -1
                  : _vm.accept,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.accept,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.accept = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.accept = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.accept = $$c
                  }
                },
              },
            }),
            _vm._v(
              "\n\t\t\t\t\tJ'accepte de transmettre mes informations\n\t\t\t\t"
            ),
          ]),
          _vm._v(" "),
          _vm.accept_msg
            ? _c(
                "p",
                {
                  staticClass: "bg-danger",
                  staticStyle: { "margin-top": "10px", padding: "10px" },
                },
                [_vm._v(_vm._s(_vm.accept_msg))]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c(
          "div",
          {
            staticClass: "btn btn-block btn-primary",
            on: {
              click: function ($event) {
                return _vm.save()
              },
            },
          },
          [
            _vm._v("\n\t\t\t\tEnregistrer "),
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "loading",
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "text-danger", staticStyle: { "margin-top": "10px" } },
          [_vm._v(_vm._s(_vm.error_msg))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }